//Archivo dedicado al menu de todos los imports de SIAP

//Imports relacionados de SIAP
//-----------Principal-----------
import Plantilla from '@/components/SIAP/Comun/Plantilla.vue';
import PersonalEvaluado from '@/components/SIAP/Evaluaciones/PersonalEvaluado.vue';
import AltaDeUsuario from '@/components/SIAP/AdministracionPersonal/AltaDeUsuario.vue';
import SolicitudesEvaluacion from '@/components/SIAP/Evaluaciones/SolicitudesEvaluacion.vue';
import NuevaSolicitud from '@/components/SIAP/Evaluaciones/NuevaSolicitud.vue';
import ConsultaPersonal from '@/components/SIAP/AdministracionPersonal/ConsultaPersonal.vue';
import EditarUsuario from '@/components/SIAP/AdministracionPersonal/EditarUsuario.vue';
import EditarSolicitud from '@/components/SIAP/Evaluaciones/EditarSolicitud.vue';
import DetalleSolicitudEvaluacion from '@/components/SIAP/Evaluaciones/DetalleSolicitudEvaluacion.vue';
import DetalleEvaluacion from '@/components/SIAP/Evaluaciones/DetalleEvaluacion.vue';
import ReporteEvaluaciones from '@/components/SISEVA/Evaluaciones/ReporteEvaluaciones.vue';
import EvaluacionesConcluidas from '@/components/SIAP/Evaluaciones/EvaluacionesConcluidas.vue';
import NuevaEstructuraOrganica from '@/components/SIAP/AdministracionPersonal/NuevaEstructuraOrganica.vue';
import Becarios from '@/components/SIAP/Becarios/Becarios.vue';
import Organigrama from '@/components/SIAP/AdministracionPersonal/Organigrama.vue';
import OrganigramaConFoto from '@/components/SIAP/AdministracionPersonal/OrganigramaConFoto.vue';
import ReporteAnualInterinatos from '@/components/SIAP/Evaluaciones/ReporteAnualInterinatos.vue';
import EditarPeriodoEvaluacion from '@/components/SIAP/Evaluaciones/EditarPeriodoEvaluacion.vue';
import HistorialDeEstructuraOrganica from '@/components/SIAP/AdministracionPersonal/HistorialDeEstructuraOrganica.vue';
import BuscarNombramientos from '@/components/SIAP/Nombramientos/BuscarNombramientos.vue';
import Nombramientos from '@/components/SIAP/Nombramientos/Nombramientos.vue';
import NuevoPuesto from '@/components/SIAP/AdministracionPersonal/NuevoPuesto.vue';
import GestionIncidencia from '@/components/SIAP/Incidencias/GestionIncidencias.vue'
import SubirDigitalIncidencia from '@/components/SIAP/Incidencias/SubidorDigitalIncidencia.vue'
import ReporteInterinatos from '@/components/SIAP/Evaluaciones/ReporteInterinatos.vue'
import ExportarExcel from '@/components/SIAP/Checador/ExportarDeExcel.vue'
import Prenomina from '@/components/SIAP/Checador/PreNomina.vue'
import calendarioChecador from '@/components/SIAP/Checador/Calendario.vue'
import asistencias from '@/components/SIAP/Checador/EventosChecador'
import NuevaSolicitudBloque from '@/components/SIAP/Evaluaciones/NuevaSolicitudBloque.vue'
import ImportarExcel from '@/components/SIAP/AdministracionPersonal/ImportarRegistros.vue'



//Se crea la lista de paths
const SIAP = [{
  path: '/SIAP/',
  component: Plantilla,
  meta: {
    RequiereAutenticacion: true,
    ValidaSesion: true,
    ObtenDatos: true,
    ObtenPermisosDelSistema: true,
    SistemaQueSeIngreso: 6
  },
  children: [{
    path: 'PersonalEvaluado',
    component: PersonalEvaluado
  },
  {
    path: 'AltaDeUsuario',
    name: 'AltaDeUsuario',
    component: AltaDeUsuario,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 1,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    path: 'SolicitudesEvaluacion',
    component: SolicitudesEvaluacion,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 3,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'NuevaSolicitud',
    name: 'NuevaSolicitud',
    component: NuevaSolicitud,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 4,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'EditarPeriodoEvaluacion',
    name: 'EditarPeriodoEvaluacion',
    component: EditarPeriodoEvaluacion,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 4,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'ConsultaPersonal',
    component: ConsultaPersonal,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 2,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'EditarUsuario',
    name: 'EditarUsuario',
    component: EditarUsuario,
    props: true
  },
  {
    path: 'EditarSolicitud',
    name: 'EditarSolicitud',
    component: EditarSolicitud,
    props: true
  },
  {
    path: 'DetalleSolicitudEvaluacion',
    name: 'DetalleSolicitudEvaluacion',
    component: DetalleSolicitudEvaluacion,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 3,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'DetalleEvaluacion',
    name: 'DetalleEvaluacion',
    component: DetalleEvaluacion,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 3,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'NuevaEstructuraOrganica',
    component: NuevaEstructuraOrganica,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 5,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'Becarios',
    name: 'Becarios',
    component: Becarios,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 6,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    path: 'Organigrama',
    name: 'Organigrama',
    component: Organigrama,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 7,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
    },
    {
      path: 'OrganigramaConFoto',
      name: 'OrganigramaConFoto',
      component: OrganigramaConFoto,
      meta: {
        RequiereAutenticacion: true,
        ValidaSesion: true,
        ObtenDatos: true,
        ObtenPermisosDelSistema: true,
        SistemaQueSeIngreso: 6,
        ModuloId: 1,
        FuncionId: 7,
        EsRequeridoValidacionDeInstitucion: true
      },
      props: true
    },
  {
    path: 'ReporteEvaluaciones',
    name: 'ReporteEvaluaciones',
    component: ReporteEvaluaciones,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 3,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'EvaluacionesConcluidas',
    name: 'EvaluacionesConcluidas',
    component: EvaluacionesConcluidas,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 3,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'ReporteAnualInterinatos',
    component: ReporteAnualInterinatos,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 2,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'ReporteInterinatos',
    component: ReporteInterinatos,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 14,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'HistorialDeEstructuraOrganica',
    component: HistorialDeEstructuraOrganica,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 11,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'BuscarNombramientos',
    component: BuscarNombramientos,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 12,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'Nombramientos',
    component: Nombramientos,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 13,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'NuevoPuesto',
    component: NuevoPuesto,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 13,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    name: 'IncidenciasGestion',
    path: 'GestionIncidencias',
    component: GestionIncidencia,
    meta: {
      tituloDeLaPagina: "Gestión de Incidencias del Personal del Poder Judicial",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 12,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    name: 'SubirDigitalIncidencia',
    path: 'SubidorDigitalIncidencia',
    component: SubirDigitalIncidencia,
    meta: {
      tituloDeLaPagina: "Registro de Incidencia en Digital",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 12,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    name: 'ExportarChecador',
    path: 'ExportarExcel',
    component: ExportarExcel,
    meta: {
      tituloDeLaPagina: "Exportar Registros de Reloj Checador",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 15,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: false
  },
  {
    name: 'PreNomina',
    path: 'PreNomina',
    component: Prenomina,
    meta: {
      tituloDeLaPagina: "Reporte Pre Nomina",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 16,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    name: 'calendarioChecador',
    path: 'Calendario',
    component: calendarioChecador,
    meta: {
      tituloDeLaPagina: "Calendario con eventos del control de Asistencia",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 16,
      EsRequeridoValidacionDeInstitucion: true
    },
    props: true
  },
  {
    name: 'Asistencias',
    path: 'CalendarioAsistencias',
    component: asistencias,
    meta: {
      tituloDeLaPagina: "Calendario del control de Asistencias",
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 3,
      FuncionId: 17,
      EsRequeridoValidacionDeInstitucion: true
    },
  },
  {
    path: 'NuevaSolicitudBloque',
    name: 'NuevaSolicitudBloque',
    component: NuevaSolicitudBloque,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 2,
      FuncionId: 26,
      EsRequeridoValidacionDeInstitucion: true
    }
  },
  {
    path: 'ImportarMovimientos',
    name: 'ImportarRegistros',
    component: ImportarExcel,
    props: true,
    meta: {
      RequiereAutenticacion: true,
      ValidaSesion: true,
      ObtenDatos: true,
      ObtenPermisosDelSistema: true,
      SistemaQueSeIngreso: 6,
      ModuloId: 1,
      FuncionId: 28,
      EsRequeridoValidacionDeInstitucion: true
    }
  }
  ]
}];

//Se regresa la lista de paths
export default SIAP;



// WEBPACK FOOTER //
// ./src/router/SIAP.js